import {acceptHMRUpdate, defineStore} from 'pinia';
import {findLastIndex as _findLastIndex, has as _has, get as _get} from 'lodash-es';
import {useBookingStepperStore} from './booking-stepper';
import {shallowRef, watch} from 'vue';
import {usePostSaleStore} from '@/stores/post-sale';
import {useDialogManagerStore} from './dialog-manager';
import {useBookingAppSettingStore} from "@/stores/booking-app-setting";
import {wrapArray} from '@/common-scripts/utilities';


export function makeSeatMap(data) {
    return Object.assign({}, {
        seat: false,
        seatNumToShow: false,
        wagon: false,
    }, data);
}

const testTravellerData = {
    name: import.meta.env.VITE_TRAVELLER_NAME || 'FILOMENA',
    surname: import.meta.env.VITE_TRAVELLER_SURNAME || 'GRASSI',
    cartafreccia: import.meta.env.VITE_TRAVELLER_CARTAFRECCIA || null,
    // birthDate: new Date((import.meta.env.VITE_TRAVELLER_BIRTHDATE || '1980-12-13')),
    email: import.meta.env.VITE_TRAVELLER_EMAIL || 'f.torrini@theorangeseed.it',
    phoneNumber: import.meta.env.VITE_TRAVELLER_PHONE || '1122334455',
    forwardDiscountCode: import.meta.env.VITE_TRAVELLER_DISCOUNTCODE || null,
    returnDiscountCode: null
};

export function formatBirthDate(date) {
    if (!(date instanceof Date)) return date;

    return [
        date.getDate().toString().padStart(2, '0'),
        (date.getMonth() + 1).toString().padStart(2, '0'),
        date.getFullYear(),
    ].join('/');
}
export function makePassenger(data = null) {
    let base = {
        data: {
            name: null,
            surname: null,
            birthDate: null,
            email: null,
            phoneNumber: null,
            phonePrefix: '+39',
            type: 'ADULT',
            age: null,
            gender: null,
            contact_consent: 'false', // true if not accept
            cartaFreccia: null,
            pitCode: null,
            forwardDiscountCode: null,
            returnDiscountCode: null
        },
        // deprecated "disclaimers" use contact_consent
        disclaimers: {
            cell: true,
            email: true,
        }
    };
    if (import.meta.env.DEV) {
        base.data = Object.assign({}, base.data, testTravellerData);
    }

    let result;
    if (data) {
        if (data.data) {
            result = Object.assign({}, base, data);
        } else {
            const resultData = Object.assign({}, base.data, data);
            result = Object.assign({}, base, {data: resultData});
        }
    } else {
        result = Object.assign({}, base);
    }

    return result;
}
export function makeInvoice() {
    let base = {
        id: null,
        // TODO: DA APPLICARE L'AUTENTICAZIONE O LA COPIA DEI DATI DELLA CARTAFRECCIA => DATO NECESSARIO CUSTOMERKEY
        cartafreccia: null,
        customerKey: null,
        name: null,

        firstName: null,
        lastName: null,
        fiscalCode: null,

        businessName: null,
        vatNumber: null,
        companyFiscalCode: null,


        address: {
            country: 'IT',
            province: null,
            city: null,
            postalCode: null,
            address: null,
        },
        recipientCode: null,
        certifiedMail: null,

        personType: 'LEGAL' // INDIVIDUAL | LEGAL
    };

    const result = Object.assign({}, base);

    return result;
}
function makeSearchFilter(pinia) {
    return {
        departureStation: shallowRef(null),
        arrivalStation: shallowRef(null),
        startDate: null,
        returnDate: null,
        adult: 1,
        children: 0,
        direction: 'ONE_WAY', // RETURN
        filterSolution: 'all',
    };
}
/**
 * Init selection
 * @param {String} offerId
 * @param {String} catalogServiceId
 * @param {Array} offers
 * @param {Object} servicesMap
 * @returns
 */
export function makeCustomizedOfferedServiceSelection(offeredService, servicesMap) {
    const result = {
        offerId: offeredService.offerId,
        catalogServiceId: offeredService.catalogServiceId,
        offered: [offeredService.id],
        offeredService,
        parameters: {}
    };

    // init service parameters value
    const serviceParameters = _get(servicesMap, ['catalog_services', offeredService.catalogServiceId, 'selection_service_parameters'], []);
    for (const serviceParameter of serviceParameters) {
        result.parameters[serviceParameter.service_id] = _get(offeredService, ['parameters', serviceParameter.service_id], serviceParameter.typeDefinition.defaultValue);
    }

    return result;
}
export function handleEvaluateSolutionResponse(res, i18n) {
    if (res === false) return false; // error just handled
    if ([true, 'true'].includes(res.validSelection)) return true; // success
    let messages = [];
    if (res && res.travelSolutions) {
        if (res.saleabilityMessages) {
            messages.push(...wrapArray(res.saleabilityMessages));
        }
        let travelSolutions = res.travelSolutions;
        if (!Array.isArray(travelSolutions)) travelSolutions = [travelSolutions];
        let offeredServices = _get(travelSolutions, [0, 'offeredServices']);
        if (offeredServices && !Array.isArray(offeredServices)) offeredServices = [offeredServices];
        if (offeredServices && _get(travelSolutions, [0, 'returnTravelSolution', 'offeredServices'])) {
            const returnOfferedServices = _get(travelSolutions, [0, 'returnTravelSolution', 'offeredServices']);
            if (Array.isArray(returnOfferedServices)) offeredServices.push(...returnOfferedServices);
            else offeredServices.push(returnOfferedServices);
        }
        if (offeredServices) {
            for (const [offerXmlId, evaluatedOffer] of Object.entries(offeredServices)) {
                if (_get(evaluatedOffer, 'status') != 'SELECTED') continue;
                let evaluatedMessages = _get(evaluatedOffer, 'bookingInfo.reportItem.messages');
                if (!Array.isArray(evaluatedMessages)) evaluatedMessages = [evaluatedMessages];
                for (const evaluatedMessage of evaluatedMessages) {
                    if (messages.includes(evaluatedMessage)) continue;
                    messages.push(evaluatedMessage);
                }
            }
        }
    }
    const dialogManagerStore = useDialogManagerStore();
    if (messages.length) {
        dialogManagerStore.openSimpleMessageDialog({
            title: i18n.t('dialogs.warning', 'Attenzione'),
            text: messages[0] // print only first?
        });
    } else {
        dialogManagerStore.openSimpleMessageDialog({
            title: i18n.t('stores.booking.handleevaluatesolutionresponse.title', 'Selezione non disponibile'),
            text: i18n.t('stores.booking.handleevaluatesolutionresponse.text', 'Non è più possibile acquistare il prezzo selezionato.')
        });
    }
    return false;
}
export function checkAndSetIfArePreSelectedOffersAndServices(travelSolutionForCustomization) {
    const postSale = usePostSaleStore();
    let selectedCustomizedOffers = {};
    if (postSale.reopenedTravel && 'change_class' == postSale.selectedEdit) {
        let selectedOfferedServices = [];
        for (let travelSolution of postSale.rightTravelSolutions) {
            for (let xmlId in travelSolution.offeredServices) {
                if (!Object.hasOwnProperty.call(travelSolution.offeredServices, xmlId)) continue;
                if (['93', 93].includes(travelSolution.offeredServices[xmlId].offerId)) continue;

                selectedOfferedServices.push({
                    trainId: travelSolution.offeredServices[xmlId].nodeId,
                    travellerXmlId: travelSolution.offeredServices[xmlId].travellerXmlId,
                    offerId: travelSolution.offeredServices[xmlId].offerId,
                    serviceId: travelSolution.offeredServices[xmlId].catalogServiceId
                });
            }
        }


        if (selectedOfferedServices.length > 0) {
            let countSelOffServ = selectedOfferedServices.length;
            for (const offXmlId in travelSolutionForCustomization.offeredServices) {
                if (!Object.hasOwnProperty.call(travelSolutionForCustomization.offeredServices, offXmlId)) continue;
                let offeredService = travelSolutionForCustomization.offeredServices[offXmlId];
				let idx = selectedOfferedServices.findIndex((offServ) => {
					if(!offeredService.is_sealable) return false;
					if (offServ.trainId == offeredService.nodeId && offServ.travellerXmlId == offeredService.travellerXmlId && offServ.offerId == offeredService.offerId && offServ.serviceId == offeredService.catalogServiceId) {
						return true;
					}
				});

                if (idx >= 0) {
                    if (!selectedCustomizedOffers[offeredService.nodeId]) selectedCustomizedOffers[offeredService.nodeId] = {};
                    selectedCustomizedOffers[offeredService.nodeId][offeredService.travellerXmlId] = makeCustomizedOfferedServiceSelection(offeredService, travelSolutionForCustomization.servicesMap);

                    countSelOffServ--;
                }
                if (countSelOffServ == 0) break;
            }
        }
    }

    return selectedCustomizedOffers;
}
function seatMap_dataToCart(seatSelection, travellersNumber) {
    let seatMap = [];
    for (const key in seatSelection) {
        if (!Object.hasOwnProperty.call(seatSelection, key)) continue;
        const trainSeats = seatSelection[key];
        if (!trainSeats) return;
        if (trainSeats.length != travellersNumber) {
            const dialogManagerStore = useDialogManagerStore();
            dialogManagerStore.openSimpleMessageDialog({
                messageType: 'error',
                text: this.$i18n.t('stores.booking.addtocart.error', 'Alcuni partecipanti non hanno il posto assegnato')
            });
            return;
        }
        for (let seatIdx = 0; seatIdx < trainSeats.length; seatIdx++) {
            const seat = trainSeats[seatIdx];
            // const traveller = this.searchTravellers[seatIdx];
            // const offer = this.evaluatedSolution.travelSolutions.offeredServices.find(o => {
            // 	return o.solutionNodeRef == seat.trainId && o.bookingInfo.traveller == traveller.xmlId;
            // });
            seatMap.push({
                // priceID: offer.xmlId,
                offeredServicesId: seat.offeredServicesId,
                seatNum: seat.seatNum,
                airCraftNumber: seat.seatToShow,
                wagon: seat.wagon,
                isFree: seat.isFree
            });
        }
    }

    return seatMap;
}


export const useBookingStore = defineStore('booking', {
    persist: {
        storage: sessionStorage,
        paths: ['searchFilters', 'searchCarnetFilters'],
        afterRestore({store}) {
            if (typeof (store.searchFilters.startDate) == 'string') store.searchFilters.startDate = new Date(store.searchFilters.startDate);
            if (typeof (store.searchFilters.returnDate) == 'string') store.searchFilters.returnDate = new Date(store.searchFilters.returnDate);
        }
    },
    state: () => ({
        searchFilters: makeSearchFilter(),
        // searchCarnetFilters: { ...{carnetId: null}, ...makeSearchFilter()},
        isRoundTrip: false,
        carnet: {
            list: null,
            selectedCarnetId: null,
            fund: null,
            selectedService: {
                label: null,
                serviceId: null,
                solutionId: null
            },
            loading: false
        },
        servicesMap: shallowRef(null),
        searchTravellers: shallowRef(null),	// array
        useCustomizedOffers: false,
        passengers: [],
        buyer: {},
        buyerIspassenger: true,
        forwardTravel: {
            evaluatedSolution: shallowRef(null),
            seats: {
                requested: false,
                selection: {},
                trainSeatMaps: {}
            }
        },
        returnTravel: {
            evaluatedSolution: shallowRef(null),
            seats: {
                requested: false,
                selection: {},
                trainSeatMaps: {}
            }
        },
        travellers: null,
        billing: makeInvoice(),
        withInvoice: false,
        tmp_canRequestSeatSelection: null,
        forwardArrivalTime: null,
        loading: false
    }),
    getters: {
        isPostSale() {
            const postSale = usePostSaleStore();

            return Boolean(postSale.travel && postSale.selectedEdit);
        },
        totalPassengers(state) {
            return state.totalAdults + state.totalChildren;
        },
        totalAdults(state) {
            return state.searchFilters.adult;
        },
        totalChildren(state) {
            return state.searchFilters.children;
        },
        selectedOffersData() {
            const offeredServices = _get(this.selectedSolutionView, 'offeredServices', {});
            // Object.assign(offeredServices, _get(this.selectedSolutionView, 'returnTravelSolution.offeredServices', {}));

            return Object.entries(offeredServices).reduce((carry, [xmlId, offeredService]) => {
                if (offeredService.status == 'SELECTED') carry.push(offeredService);
                return carry;
            }, []);
        },
        selectedTotalPrice() {
            if (!this.forwardTravel.evaluatedSolution) return null;

            const travelSolution = this.returnTravel.evaluatedSolution ?
                this.returnTravel.evaluatedSolution.travelSolutions : this.forwardTravel.evaluatedSolution.travelSolutions;
            if (!Array.isArray(travelSolution.offeredServices)) travelSolution.offeredServices = [travelSolution.offeredServices];
            if (travelSolution.returnTravelSolution && !Array.isArray(travelSolution.returnTravelSolution.offeredServices)) {
                travelSolution.returnTravelSolution.offeredServices = [travelSolution.returnTravelSolution.offeredServices];
            }

            const offeredServices = [...travelSolution.offeredServices, ...(travelSolution.returnTravelSolution ?
                travelSolution.returnTravelSolution.offeredServices : [])];

            const selectedOfferedServices = offeredServices.filter((offeredService) => {
               if ('SELECTED' == offeredService.status) return offeredService;
            });

            return selectedOfferedServices.reduce((a, p) => {
                if (p.price && p.price.amount) a += Number(p.price.amount);
                return a;
            }, 0);
        },
        selectedSeatOffersData(state) {
            return this.selectedOffersData.filter(o => {
                return ['SEAT', 'BED'].includes(_get(state.servicesMap, ['catalog_services', o.catalogServiceId, 'type']));
            });
        },
        selectedSolutionView(state) {
            // TODO: CONTROLLARE ... DOVREBBE ANDAR BENE "return _get(this.evaluatedSolution, 'viewTravelSolutions.0')"
            return _get(this.evaluatedSolution, 'viewTravelSolutions.0');
        },
        isEvaluatedValid() {
            return this.evaluatedSolution && ['true', true].includes(this.evaluatedSolution.validSelection);
        },
        evaluatedOffers() {
            if (!this.evaluatedSolution || !this.evaluatedSolution.travelSolutions) return null;
            const travelSolutions = Array.isArray(this.evaluatedSolution.travelSolutions) ? this.evaluatedSolution.travelSolutions : [this.evaluatedSolution.travelSolutions];
            return travelSolutions.reduce((res, travelSolution) => {
                const offeredServices = Array.isArray(travelSolution.offeredServices) ? travelSolution.offeredServices : [travelSolution.offeredServices];
                return offeredServices.reduce((res, offeredService) => {
                    if (!offeredService) {
                        console.warn('invalid', offeredServices);
                    }
                    if (!offeredService || offeredService.status != 'SELECTED') return res;
                    res[offeredService.xmlId] = offeredService;
                    return res;
                }, res);
            }, {});
        },
        travellerParameterErrors(state) {
            return _get(state, 'evaluatedSolution._invalid_traveller_parameters');
        },
        passengersSelectionMap(state) {
            if (!state.passengers) return [];
            return state.passengers.map(p => {
                const result = {
                    travellerXmlId: p.data.xmlId,
                    passengerData: p.data
                };

                if (_has(this.selectedSolutionView, 'trains')) {
                    result.trainSelections = this.selectedSolutionView.trains.map(t => {
                        return {
                            trainId: t.id,
                            selectedOfferedServices: this.selectedOffersData.filter(o => o.nodeId == t.id && o.travellerXmlId == p.data.xmlId),
                            seatSelection: _get(this.seatSelection, t.id, []).find(selelection => selelection.travellerXmlId == p.data.xmlId)
                        };
                    })
                }

                return result;
            });
        },
        travelDirection() {
            return useBookingStepperStore().isAfterForwardTripSteps ? 'returnTravel' : 'forwardTravel';
        },
        requestSeatSelection(state) {
            return state[this.travelDirection].seats.requested;
        },
        seatSelection(state) {
            return state[this.travelDirection].seats.selection;
        },
        evaluatedSolution(state) {
            return state[this.travelDirection].evaluatedSolution;
        },
        trainSeatMaps(state) {
            return state[this.travelDirection].seats.trainSeatMaps;
        }
    },
    actions: {
        initCustomizedOffers(services){
            const selectedCustomizedOffers = checkAndSetIfArePreSelectedOffersAndServices(this.travelSolutionForCustomization);

            if (Object.keys(selectedCustomizedOffers).length <= 0) {
                for (const train of this.travelSolutionForCustomization.trains) {
                    if(!services[train.id] || !services[train.id].travellers) continue;
                    for (const passenger of this.passengers) {
                        if(!services[train.id].travellers[passenger.data.xmlId] || services[train.id].travellers[passenger.data.xmlId].length == 0) continue;
                        for (const catalogService of services[train.id].travellers[passenger.data.xmlId]) {
                            const offer = catalogService.offers.find(s => {
                                return s.selectable;
                            });
                            if(!offer) continue;
                            if(!selectedCustomizedOffers[train.id]) selectedCustomizedOffers[train.id] = {};
                            const offers = offer.offered || offer.offers;
                            const offeredService = this.travelSolutionForCustomization.offeredServices[offers[0]];
                            selectedCustomizedOffers[train.id][passenger.data.xmlId] = makeCustomizedOfferedServiceSelection(offeredService, this.travelSolutionForCustomization.servicesMap);
                            break;
                        }
                    }
                }
            }

            this.selectedCustomizedOffers = selectedCustomizedOffers;
        },
        initCustomizedOffersWithoutOffersMap(){
            const priceSelected = this.selectedSolutionView.priceGrid[trainId].matrix[offerId][catalogServiceId];
            this.evaluatedSolution = null;
            this.selectedTrainGridOffers[trainId] = {
                offerId,
                catalogServiceId,
                offers: priceSelected.offers,
                totalPrice: priceSelected.totalPrice
            };


            const selectedCustomizedOffers = {};
            const travellers = this.travelSolutionForCustomization.travellers;
            for (const train of this.travelSolutionForCustomization.trains) {
                for (const traveller of travellers) {
                    selectedCustomizedOffers[train.id][traveller.xmlId] = {
                        catalogServiceId: catalogService.id,
                        offerId: offer.offerId,
                        offered: offer.offered || offer.offers
                    };
                }
            }




            // const selectedCustomizedOffers = {};
            for (const train of this.travelSolutionForCustomization.trains) {
                if(!services[train.id] || !services[train.id].travellers) continue;
                for (const passenger of this.passengers) {
                    if(!services[train.id].travellers[passenger.data.xmlId] || services[train.id].travellers[passenger.data.xmlId].length == 0) continue;
                    for (const catalogService of services[train.id].travellers[passenger.data.xmlId]) {
                        const offer = catalogService.offers.find(s => {
                            return s.selectable;
                        });
                        if(!offer) continue;
                        if(!selectedCustomizedOffers[train.id]) selectedCustomizedOffers[train.id] = {};
                        selectedCustomizedOffers[train.id][passenger.data.xmlId] = {
                            catalogServiceId: catalogService.id,
                            offerId: offer.offerId,
                            offered: offer.offered || offer.offers
                        };
                        break;
                    }
                }
            }
            this.selectedCustomizedOffers = selectedCustomizedOffers;
        },

        setStartDate(date) {
            if (!(date instanceof Date)) date = new Date(date) ;
            date.setMinutes(0);
            date.setSeconds(0);

            this.searchFilters.startDate = date;
        },
        setReturnDate(date) {
            if (!(date instanceof Date)) date = new Date(date) ;
            date.setMinutes(0);
            date.setSeconds(0);

            this.searchFilters.returnDate = date;
        },
        setRequestSeatSelection(booleanValue) {
            this[this.travelDirection].seats.requested = booleanValue;
        },
        setRoundTripStatus(val) {
            this.isRoundTrip = val;
            if (this.isRoundTrip) {
                const d = new Date(this.searchFilters.startDate.toDateString());
                if (import.meta.env.DEV) d.setDate(this.searchFilters.startDate.getDate() + 1);
                d.setHours(this.searchFilters.startDate.getHours() + 1);
                d.setMinutes(this.searchFilters.startDate.getMinutes())
                this.searchFilters.returnDate = d;
                this.searchFilters.direction = 'FORWARD';
            } else {
                this.searchFilters.returnDate = null;
                this.searchFilters.direction = 'ONE_WAY';
            }
            useBookingStepperStore().switchRoundTripStatus(val);
        },
        setSeatSelection(data = {}, isReturn = null) {
            this[this.travelDirection].seats.selection = data;
            if (Object.keys(this[this.travelDirection].seats.selection).length === 0) {
                this[this.travelDirection].evaluatedSolution = null;
            }
        },
        setEvaluatedSolution(data = null, isReturn = null) {
            if (!data) {
                this[this.travelDirection].evaluatedSolution = data;
                return ;
            }

            if (data.trainSeatMaps) {
                this.setTrainSeatMaps(data.trainSeatMaps, this.travelDirection);
                delete data.trainSeatMaps;
            }
            if (data.servicesMap) {
                this.updateServicesMap(data.servicesMap);
                delete data.servicesMap;
            }
            this[this.travelDirection].evaluatedSolution = data;
        },
        setTrainSeatMaps(trainSeatMaps, direction = null) {
            if (direction === null) direction = this.travelDirection;
            this[direction].seats.trainSeatMaps = trainSeatMaps;
        },
        setSeat(seat) {
            if (useBookingStepperStore().isAfterForwardTripSteps) {
                if (!this.returnTravel.seats.selection) this.returnTravel.seats.selection = {};
                if (!this.returnTravel.seats.selection[seat.trainId]) this.returnTravel.seats.selection[seat.trainId] = [];
                this.returnTravel.seats.selection[seat.trainId].push(seat);
            } else {
                if (!this.forwardTravel.seats.selection) this.forwardTravel.seats.selection = {};
                if (!this.forwardTravel.seats.selection[seat.trainId]) this.forwardTravel.seats.selection[seat.trainId] = [];
                this.forwardTravel.seats.selection[seat.trainId].push(seat);
            }
        },
        setSeatMapDataToAddToCart() {
            let seatMap = [];
            if (this.forwardTravel.seats.selection && Object.keys(this.forwardTravel.seats.selection).length > 0) {
                seatMap = [...seatMap, ...seatMap_dataToCart(this.forwardTravel.seats.selection, this.searchTravellers.length)];

                if (this.returnTravel.seats.selection && Object.keys(this.returnTravel.seats.selection).length > 0) {
                    seatMap = [...seatMap, ...seatMap_dataToCart(this.returnTravel.seats.selection, this.searchTravellers.length)];
                }

                return seatMap;
            } else {
                return null;
            }
        },
        setTravelSolutionCustomizable(travelSolution, servicesMap){
            if(!travelSolution){
                this.travelSolutionForCustomization = null;
                this.selectedCustomizedOffers = null;
                return;
            }
            this.setEvaluatedSolution();
            travelSolution.servicesMap = servicesMap;
            this.travelSolutionForCustomization = travelSolution;
            const postSale = usePostSaleStore();
            // TODO: DA FINIRE INSIEME A travelSolution.vue (vedi git locale mio - Fabio)
            // if (postSale.reopenedTravel) {
            // 	const editedTravelSolution = postSale.reopenedTravel.travel.travelSolutions.map((travelSolution) => {
            // 		if (travelSolution.xmlId == postSale.selectedTravelSolutionXmlId) {
            // 			return travelSolution;
            // 		}
            // 	});
            //
            //
            // } else if (travelSolution.offers_map) {
            if (travelSolution.offers_map) {
                this.initCustomizedOffers(travelSolution.offers_map);
            } else {
                // this.initCustomizedOffersWithoutOffersMap();
            }
        },
        setSelectedCustomizedOffer(trainId, travellerId, offerId, catalogServiceId, offered){
            if(!this.selectedCustomizedOffers) this.selectedCustomizedOffers = [];
            if(!this.selectedCustomizedOffers[trainId]) this.selectedCustomizedOffers[trainId] = {};
            // if(!this.selectedCustomizedOffers[trainId]) this.selectedCustomizedOffers[props.trainId] = {};
            const offeredService = this.travelSolutionForCustomization.offeredServices[offered[0]];
            this.selectedCustomizedOffers[trainId][travellerId] = makeCustomizedOfferedServiceSelection(offeredService, this.servicesMap);
            this.setEvaluatedSolution();
        },

        increment(travellerCategory) {
            this.searchFilters[travellerCategory]++;
        },
        decrement(travellerCategory) {
            if (travellerCategory == 'adult' && this.totalAdults == 1) return;
            if (this.searchFilters[travellerCategory] == 0) return;
            this.searchFilters[travellerCategory]--;
        },

        /**
         *
         * @param {String} startDate if setted is a search more
         * @returns
         */
        async searchSolutions(startDate) {
            const dialogManagerStore = useDialogManagerStore();
            const appStore = useBookingAppSettingStore();
            const stepper = useBookingStepperStore();
            const postSale = usePostSaleStore();
            const loadingDialog = dialogManagerStore.showLoadingOverlay({
                title: this.$i18n.t('dialogs.search_solutions.title', "Ricerca soluzioni in corso ..."),
            });

            this.loading = true;
            let selectedPostSaleDetails = null;
            let travelSolutions = null;
            let travellers = this.travellers;
            if (postSale.reopenedTravel) {
                travellers = postSale.reopenedTravel.travel.travellers;
                selectedPostSaleDetails = postSale.selectedPostSaleDetails;
                travelSolutions = postSale.reopenedTravel.reopen.travel.travelSolutions
            }

            const forwardTrip = this.isRoundTrip && this.forwardTravel.evaluatedSolution ?
                this.forwardTravel.evaluatedSolution.travelSolutions : null;

            let response;
            try {
                let dataToSend = {
                    from: this.searchFilters.departureStation.service_id,
                    to: this.searchFilters.arrivalStation.service_id,
                    start: startDate || this.searchFilters.startDate.toISOString(),
                    adult: this.searchFilters.adult,
                    children: this.searchFilters.children,
                    direction: 'ONE_WAY',
                    selectedPostSaleDetails: selectedPostSaleDetails,
                    travelSolutions: travelSolutions,
                    travellers: travellers,
                    filterSolution: this.searchFilters.filterSolution,
                    forwardTrip: forwardTrip,
                    seatMap: forwardTrip ? this.setSeatMapDataToAddToCart() : null
                    // mode: 'enhanced'
                };

                if (this.isRoundTrip) {
                    dataToSend.direction = 'FORWARD';
                    dataToSend.roundTrip = true;
                    dataToSend.returnTripDate = this.searchFilters.returnDate.toISOString();

                    if (useBookingStepperStore().isAfterForwardTripSteps) {
                        if (!startDate) dataToSend.start = dataToSend.returnTripDate;
                        const from = dataToSend.from;
                        dataToSend.from = dataToSend.to;
                        dataToSend.to = from;
                        dataToSend.direction = 'RETURN';
                        dataToSend.forwardTripDate = this.searchFilters.startDate.toISOString();
                        dataToSend.travellers = this.searchTravellers.map((passenger) => {
                            return {
                                type: passenger.type,
                                parameters: passenger.parameters,
                                xmlId: passenger.xmlId,
                            };
                        });
                    }
                }

                response = await this.$axios.post('trenitalia/ricerca', dataToSend);
            } finally {
                loadingDialog.close();
                this.loading = false;
            }

            if (!response || 200 != response.status) {
                throw new Error(response || 'Unexpected error - cod.SS-01');
            }

            if (response.data.errors) {
                if (import.meta.env.DEV) console.error('SS-02');
                if (import.meta.env.DEV) console.error(response.data);
                let message = '';
                for (let error of response.data.errors) {
                    message += error.toString() + ' ';
                }

                await dialogManager.openSimpleMessageDialog({
                    title: this.$i18n.t('dialogs.warning', 'Attenzione'),
                    text: message
                });
                stepper.goBack(); // return to search step if fail

                return false;
            }

            if (response.data.communications) {
                for (const communication of response.data.communications) {
                    await useDialogManagerStore().openSimpleMessageDialog({
                        messageType: 'warning',
                        textHTML: communication
                    });
                }
            }

            return this.elaborateSearchResponseWithReturnTravelSolutions(response);
        },
        async validate() {
            if (!this.isEvaluatedValid) return this.getAvailability({withSeatsSelection: this.requestSeatSelection});

            const postData = {
                travelSolutions: _get(this.evaluatedSolution, 'travelSolutions'),
                travellers: this.passengers.map(p => p.data),
                mode: 'travellers'
            };
            const response = await this.$axios.post("trenitalia/get-availability", postData);
            if (!response) {
                await Promise.resolve();
                return {validSelection: false};
            } else if (false == response.data.validSelection) {
                return response.data;
            }

            this.setEvaluatedSolution(response.data);
            await Promise.resolve(); // wait for getters to be updated
            return response.data;
        },
        async getAvailability({travelSolutions, travellers, selectedOffer, customerKey, withSeatsSelection} = {}) {
            if ('true' == import.meta.env.VITE_CACHE_EVALUATE) {
                let data;
                if (useBookingStepperStore().isAfterForwardTripSteps) {
                    data = sessionStorage.getItem('evaluated-return-solution');
                } else {
                    data = sessionStorage.getItem('evaluated-solution');
                }

                if (data) {
                    this.setEvaluatedSolution(JSON.parse(data));
                    return this.evaluatedSolution;
                }
            }
            if (!travellers) {
                const tmp = _get(this.forwardTravel.evaluatedSolution, 'travellers');
                if (tmp) {
                    travellers = tmp.map((traveller) => {
                        const passanger = this.passengers.find((p) => p.data.xmlId == traveller.xmlId);
                        if (!passanger) return;
                        return {...traveller, ...passanger.data};
                    });
                } else {
                    travellers = this.passengers.map(p => p.data);
                }
            }

            const postData = {
                travelSolutions: travelSolutions,
                travellers: travellers,
                selectedOffer: selectedOffer,
                // customerKey: this.buyer.data.cartaFreccia,  // TODO: SOLO PER LA CERTIFICAZIONE !  --- DA CANCELLARE --- !!!
                customerKey: customerKey || (this.buyer.customerKey || null),
                withSeatsSelection: withSeatsSelection
            };

            const response = await this.$axios.post("trenitalia/get-availability", postData).catch((e) => {
                console.error(e);
                // todo: ...come gestire gli errori ? solo un generic o passare i message interni di Trenitalia ?
            });

            if (!response) {
                useDialogManagerStore().openSimpleMessageDialog({
                    title: this.$i18n.t('stores.booking.getavailability.unexpected_error', 'Errore imprevisto'),
                    text: this.$i18n.t('common.errors.unexpected_error', "Si è verificato un errore imprevisto. Per favore riprovare."),
                    messageTypes: 'error'
                });
                return false;
            }
            if ([false, 'false'].includes(response.data.validSelection)) {
                const isSuccess = handleEvaluateSolutionResponse(response.data, this.$i18n);
                if (!isSuccess) { // evaluation is not valid so show a generic error
                    await useDialogManagerStore().openSimpleMessageDialog({
                        title: this.$i18n.t('stores.booking.getavailability.not_available', 'Selezione non disponibile'),
                        text: this.$i18n.t('stores.booking.getavailability.not_bookable', 'Siamo spiacenti ma questa soluzione non è prenotabile, riprovare o provare con un\'altra'),
                        messageTypes: 'error'
                    });
                }
                return false;
            }

            if (_get(response, 'data.servicesMap')) this.updateServicesMap(_get(response, 'data.servicesMap'));
            this.setEvaluatedSolution(response.data);
            this.resetTravellers(response.data.travellers);


            if('true' == import.meta.env.VITE_CACHE_EVALUATE) {
            	if (useBookingStepperStore().isAfterForwardTripSteps) {
            		sessionStorage.setItem('evaluated-return-solution', JSON.stringify(response.data));
            	} else {
            		sessionStorage.setItem('evaluated-solution', JSON.stringify(response.data));
            	}
            }

            await Promise.resolve(); // wait for getters to be updated

            return response.data;
        },
		async addToCart(target = 'ticket', { loadingMessage = null, successDialogMessage = null, errorDialogMessage = null } = {}){
			if(!this.isEvaluatedValid) return;
			if(this.passengers.length != this.searchTravellers.length) throw new Error('Traveller data missing');

            const billing = this.withInvoice ? this.billing: null;
            const solutions = this.returnTravel.evaluatedSolution ? this.returnTravel.evaluatedSolution.travelSolutions : this.forwardTravel.evaluatedSolution.travelSolutions;
            let dataToSend = {
                buyer: this.buyer ? this.buyer.data : null,
                travellers: this.evaluatedSolution.travellers,
                // travellers: this.passengers.map(p => p.data),
                withInvoice: this.withInvoice,
                billing: billing,
                solutions: solutions,
                seatMap: this.setSeatMapDataToAddToCart(),
                target: target,
                confirm: import.meta.env.DEV // for test
            };

            let response;
            if('true' == import.meta.env.VITE_SKIP_PAYMENT) {
                console.log('dataToSend', dataToSend);
                response = { data: { success: true} }
            } else {
                response = await this.$axios.post('trenitalia/add-to-cart', dataToSend).catch((e) => {
                    if (e.response && e.response.data.message) {
                        return {error: true, message: e.response.data.message}
                    }
                    return false;
                });
            }

            if(response && response.error) return response;
            if (!response.data.success) throw new Error(response.data.message || 'Unexpected error - cod.ATC-01');

            if (import.meta.env.DEV) {
                const dialog = useDialogManagerStore();
                await dialog.openSimpleMessageDialog({
                    messageType: 'success',
                    title: successDialogMessage || this.$i18n.t('dialogs.success', 'Operazione effettuata con successo !')
                });
            }

            // reset local store
            const stepper = useBookingStepperStore();
            stepper.reset();
            this.reset();

            setTimeout(() => {
                if (_has(response, 'data.redirect_url')) window.top.location.href = _get(response, 'data.redirect_url');
                else window.top.location.reload();
            }, 100);
        },

        // merge services maps
        updateServicesMap(servicesMap) {
            this.servicesMap = {
                catalog_services: Object.assign({}, _get(this.servicesMap, 'catalog_services'), _get(servicesMap, 'catalog_services')),
                offers: Object.assign({}, _get(this.servicesMap, 'offers'), _get(servicesMap, 'offers'))
            };
        },
        updateTravellers(travellers) {
            this.travellers = Array.isArray(travellers) ? travellers : [travellers];
        },
        elaborateSearchResponseWithReturnTravelSolutions(response) {
            response = response.data || response;
            this.updateServicesMap(response.servicesMap || response.serviceMap);
            this.updateTravellers(response.travellers);
            let newViewItems = response.travelSolutions.map(view => {
                view.travellers = response.travellers; // why this map?    // TODO: deprecated
                return view;
            });

            return newViewItems;
        },

        unsetSeat(trainIndex, waginId, seatNum=null) {
            if (!this.seatSelection[trainIndex]) return false;

            for (let i = 0; i < this.seatSelection[trainIndex].length; i++) {
                const seat = this.seatSelection[trainIndex][i];
                if (seat.wagon == waginId) {
                    if (!seatNum || seat.seatNum == seatNum) {
                        const res = seat.seatNum;
                        this.seatSelection[trainIndex].splice(i, 1);
                        return res; // found
                    }
                }
            }

            return false;
        },
        resetTravellers(travellers) {
            if (travellers && !Array.isArray(travellers)) travellers = [travellers];

            if (travellers && travellers.length) {
                const passengers = [];
                for (const traveller of travellers) {
                    let travelPassenger = null;
                    for (const passenger of this.passengers) {
                        if (passenger.data.xmlId != traveller.xmlId) continue;
                        travelPassenger = passenger;
                        break;
                    }
                    if (travelPassenger) {
                        passengers.push(travelPassenger);
                    } else {
                        const passenger = makePassenger(traveller);

                        passengers.push(passenger);
                    }
                }
                this.passengers = passengers;
                this.buyer = JSON.parse(JSON.stringify(passengers[0]));
                this.searchTravellers = travellers.map(p => p.data || p);
            } else {
                this.passengers = [];
                this.buyer = {};
                this.searchTravellers = [];
            }
        },
        resetpassengersCartaFreccia() {
            console.log('reset all cartaFreccia, why?');
            if (!this.passengers || this.passengers.length == 0) return;
            for (const passenger of this.passengers) {
                passenger.data.cartaFreccia = passenger.data.customerKey || null;
                passenger.data.cartaFrecciaErr = false;
            }
        },
        reset() {
            this.$reset();
            // Object.assign(this.searchFilters, makeSearchFilter());
        },
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useBookingStore, import.meta.hot));
}